import lodash from "lodash";

export const displayUserName = (user?: { firstName: string; lastName: string; }): string => {

  if(!user) {
    return "N/A";
  }

  if(user?.firstName && user.firstName === user.lastName) {
    return user.firstName.replace(/\w+/g, lodash.capitalize)
  }
  return (`${user?.firstName  } ${  user?.lastName}`).replace(/\w+/g, lodash.capitalize)
}
